import React from "react";

export function RequiredMark() {
  return <span className="text-danger">*</span>;
}
